import React from 'react';
import {Link} from 'gatsby';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import { useMediaQuery, Grid } from '@material-ui/core';
import { LearnMoreLink, Image } from 'components/atoms';
import { SectionHeader } from 'components/molecules';
import { CardBase } from 'components/organisms';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  fontWeight900: {
    fontWeight: 900,
  },
  logo: {
    maxWidth: 100,
  },
}));

const Brands = props => {
  const { data, className, ...rest } = props;
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <div className={className} {...rest}>
      <Grid container spacing={isMd ? 4 : 2}>
        <Grid item xs={12}>
          <Grid container spacing={isMd ? 4 : 2}>
            <Grid item xs={12} md={6}>
           
            </Grid>
            <Grid item xs={12} md={6} data-aos="fade-up">
             
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid
            container
            spacing={isMd ? 4 : 2}
            direction={isMd ? 'row' : 'column-reverse'}
          >
            <Grid item xs={12} md={6} data-aos="fade-up">
              <Grid container spacing={2}>
                {data.map((item, index) => (
                  <Grid item xs={4} key={index}>
                    <CardBase withShadow liftUp>
                      <Image
                        src={item.logo}
                        alt={item.name}
                        className={classes.logo}
                        lazy={false}
                      />
                    </CardBase>
                  </Grid>
                ))}
              </Grid>
            </Grid>
            <Grid item xs={12} md={6} data-aos="fade-up">
              <SectionHeader
              title= {
                  <span>
                                 <Typography  variant="h4" component="span" className ={classes.fontWeight900}>Our </Typography>
                    <Typography color="secondary" variant="h3" component="span" className ={classes.fontWeight900}>Global Partners </Typography>
                    <Typography  variant="h4" component="span" className ={classes.fontWeight900}>are leading the  </Typography>
                    <Typography color="secondary" variant="h3" component="span" className= {classes.fontWeight900}>Technological revolution</Typography>
                    <Typography  variant="h4" component="span" className ={classes.fontWeight900}> across the world.  </Typography>
                   
                  </span>
                
              }
      
                subtitle="They are the early adaptors and have carved a niche for themselves. We believe that their technologies are improving and fastening the scientific processes."
                align="left"
                label="BRANDS WE ARE INVOLVED WITH"
                ctaGroup={[
                  <Link to ='/Genomic'>
                  <LearnMoreLink
                  color= 'secondary'
                    title="Explore products from brands"
                  
                    variant="h6"
                  />
                  </Link>
                ]}
                disableGutter
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

Brands.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
  /**
   * data to be rendered
   */
  data: PropTypes.array.isRequired,
};

export default Brands;
